<template>
  <div>
    <!-- 写真 -->
    <p class="taC mc15">
      <img
        v-if="photoData"
        :src="getPhotoUrl(photoData)"
        :alt="companyName"
        class="offer-img-main image-height-auto"
      >
    </p>
    <p
      class="-caption pega-pre-wrap"
      v-text="caption"
    />

    <!-- メイン記事 -->
    <div class="contents-inner">
      <div
        class="bg-stripe-type01 text-block"
        :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_red.png) repeat left;`"
      >
        <p
          class="fwB pega-pre-wrap"
          data-test="title"
          v-text="title"
        />
      </div>
      <p
        class="text-block pega-pre-wrap"
        data-test="body"
        v-text="body"
      />
      <hr class="hr-type-01">
      <job-appeal-point-sp
        :pr-codes="prCodes"
        :is-search-result="true"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import JobAppealPointSp from '@/components/molecules/JobAppealPointSp'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  components: {
    JobAppealPointSp
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    photoData: {
      type: Object,
      default: null
    },
    caption: {
      type: String,
      default: ''
    },
    prCodes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
